import { useState } from "react";
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Form,
    FormGroup,
    Input,
    Label,
    Row,
    Spinner
} from "reactstrap";

import { Link, useNavigate } from "react-router-dom";

import { toast } from "react-toastify";

import "../styles/RegisterPage.css"

import { register } from "../service/authApi";
import Footer from "../../Dashboard/Footer";

const RegisterPage = () => {

    const navigate = useNavigate();

    const [loading, setLoading] =
        useState(false);

    const [formData, setFormData] = useState({

        name: "",

        email: "",

        phoneNumber: "",

        gender: "Male",

        password: "",

        confirmPassword: ""

    });

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {

        setFormData({

            ...formData,

            [e.target.name]:
                e.target.value

        });

    };

   const handleSubmit = async (
    e: React.FormEvent
) => {

    e.preventDefault();

    if (!formData.name.trim())
        return toast.error("Name is required");

    if (!formData.email.trim())
        return toast.error("Email is required");

    if (!formData.phoneNumber.trim())
        return toast.error("Phone Number is required");

    if (!formData.password)
        return toast.error("Password is required");

    if (
        formData.password !==
        formData.confirmPassword
    )
        return toast.error("Passwords do not match");

    try {

        setLoading(true);

        const result = await register({

            name: formData.name,

            email: formData.email,

            password: formData.password,

            gender: "Male",

            phoneNumber: formData.phoneNumber,

            role: 4

        });

        sessionStorage.setItem(
            "registerUserId",
            result.userId
        );

        sessionStorage.setItem(
            "registerEmail",
            formData.email
        );

        sessionStorage.setItem(
            "registerPhone",
            formData.phoneNumber
        );

        toast.success(result.message);

        navigate("/verify-account");

    }
    catch (error: any) {

        toast.error(
            error?.response?.data?.message ??
            "Registration failed"
        );

    }
    finally {

        setLoading(false);

    }

};

    return (

      <>
        <div className="register-page">

            <Container>

                <Row className="justify-content-center align-items-center register-row">
                    <Col xl="6" lg="7" md="9" sm="11" xs="12">
                        <Card className="register-card " style={{borderRadius:"30px"}}>

                            <CardBody className="p-4">

                                <div className="text-center mb-4">

                                   <img src={`${process.env.PUBLIC_URL}/assets/PriceWorth_Logo.WebP`} alt="logo" className="brand-circle" />

                                    <h2 className="price-logo">
                                        Price<span>Worth</span>
                                        <sup>™</sup>
                                    </h2>

                                    <p className="register-subtitle">
                                        Create your account and start your journey.
                                    </p>

                                </div>

                                <Form
                                    onSubmit={handleSubmit}
                                >

                                    <FormGroup floating>


                                        <Input
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            placeholder=""
                                        />
                                        <Label>Name</Label>

                                    </FormGroup>

                                    <FormGroup floating>


                                        <Input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder=""
                                        />
                                        <Label>Email</Label>

                                    </FormGroup>

                                    <FormGroup floating>


                                        <Input
                                            name="phoneNumber"
                                            value={formData.phoneNumber}
                                            onChange={handleChange}
                                            placeholder=""
                                        />
                                        <Label>Phone Number</Label>

                                    </FormGroup>

                                    {/* <FormGroup>


                                        <Input
                                            type="select"
                                            name="gender"
                                            value={formData.gender}
                                            onChange={handleChange}
                                        >
                                            <option>Select Gender</option>
                                            <option>Male</option>

                                            <option>Female</option>

                                            <option>Other</option>

                                        </Input>

                                    </FormGroup> */}

                                    <FormGroup floating>


                                        <Input
                                            type="password"
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            placeholder=""
                                        />
                                        <Label>Password</Label>

                                    </FormGroup>

                                    <FormGroup floating>


                                        <Input
                                            type="password"
                                            name="confirmPassword"
                                            value={formData.confirmPassword}
                                            onChange={handleChange}
                                            placeholder=""
                                        />
                                        <Label>Confirm Password</Label>

                                    </FormGroup>

                                    <Button color="primary"  className="register-btn w-100 mt-3" disabled={loading}>

                                        {
                                            loading ? (
                                                <>
                                                    <Spinner size="sm" className="me-2" />
                                                    Creating Account...
                                                </>
                                            ) : (
                                                "Create Account"
                                            )
                                        }
                                    </Button>

                                </Form>

                                <div className="text-center mt-4">

                                    Already have an account?

                                    <Link
                                        to="/login"
                                        className="ms-2"
                                    >

                                        Login

                                    </Link>

                                </div>

                            </CardBody>

                        </Card>

                    </Col>

                </Row>

            </Container>

        </div>
        <Footer/>
      </>

    );

};

export default RegisterPage;